<template lang="html">
  <img
    class="brand-logo"
    src="@/assets/logo.svg"
    alt="Omroep West"
    width="260"
  />
  <h2 class="title">
    Ik ga akkoord met de verwerking van mijn persoonsgegevens zoals beschreven
    in het
    <a
      href="https://www.omroepwest.nl/over-omroep-west/privacyverklaring"
      target="_blank"
      rel="noopener noreferrer"
      class="text-dark"
      >privacybeleid</a
    >
  </h2>
  <div class="d-grid gap-2">
    <button
      type="button"
      class="btn btn-secondary text-light btn-lg rounded-0"
      @click="saveQuestionGdpr()"
    >
      <span>Akkoord en doorgaan</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "QuestionGdprScreen",
  data: () => ({}),
  computed: {},
  methods: {
    saveQuestionGdpr() {
      this.$store.commit("setQuestionGdpr", "true");
      let data = {};
      data.vendor = process.env.VUE_APP_VENDOR;
      data.first_name = this.$store.getters.getFirstName;
      data.last_name = this.$store.getters.getLastName;
      data.phone = "";
      data.email = this.$store.getters.getEmail;
      data.company = "";
      data.question_1 = this.$store.getters.getQuestionOne;
      data.question_2 = this.$store.getters.getQuestionTwo;
      data.question_3 = "";
      data.question_4 = "";
      data.scanned = false;
      this.$store.dispatch("saveVisitor", data);
    },
  },
};
</script>

<style lang="css" scoped>
h2 {
  font-size: 1.4rem;
  color: #ffffff !important;
  font-weight: 600;
  line-height: 1.5;
  margin-bottom: 24px;
}
.brand-logo {
  margin-bottom: 20px;
}
a {
  color: #ffffff !important;
  text-decoration: underline;
}
button {
  background-color: #ffffff !important;
  color: #db011c !important;
  border: none !important;
  min-height: 56px;
  font-weight: 600;
  font-size: 1rem;
}
button:hover {
  background-color: #f0f0f0 !important;
}

@media (min-width: 768px) {
  h2 {
    font-size: 1.6rem;
  }

  button {
    min-height: 68px;
    font-size: 1.1rem;
  }
}
</style>
